import React from 'react';
import UPShowSecurity from '@upshow/auth';
import UPshowLogo from './assets/UPshow_logo_login.png';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import { client } from './api/axios';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import RemoteControlTheme from './styles/defaultTheme';
import UserContainer from './components/UserContainer';
import Landing from './screens/Landing/Landing';

const urlParams = new URLSearchParams(window.location.search);
const skipLandingPage = urlParams.get('bypassLanding') === 'true';

const AUTH_SCOPES = ['openid', 'remote_control'];
const windowWidth = window.screen.width;

function App () {
    return (
        <ThemeProvider theme={RemoteControlTheme}>
            <CssBaseline />
            {windowWidth < 900 || skipLandingPage
                ? <AppBrowser />
                : <Landing />}
        </ThemeProvider>
    );
}

function AppBrowser () {
    return (
        <BrowserRouter>
            <UPShowSecurity
              oktaBaseURL={process.env.REACT_APP_OKTA_URL_BASE}
              issuer={process.env.REACT_APP_OKTA_ISSUER_URL}
              clientId={process.env.REACT_APP_OKTA_CLIENT_ID}
              baseURL={window.location.origin}
              scopes={AUTH_SCOPES}
              login={{ className: 'WidgetLogin', logo: UPshowLogo }}>
                <ApolloProvider client={client}>
                    <UserContainer />
                </ApolloProvider>
            </UPShowSecurity>
        </BrowserRouter>
    );
}

export default App;
